import { normalizeNamespace } from './client';

/**
 * Lists API service
 */
export class ListsApi {
  constructor(apiClient) {
    this.client = apiClient;
  }

  /**
   * Get paginated list of lists
   */
  getLists(namespace, params = {}) {
    const ns = normalizeNamespace(namespace);
    const {
      offset, limit, view, filter, sortby, source,
    } = params;
    const queryParams = {
      ...(offset !== undefined && { offset }),
      ...(limit !== undefined && { limit }),
      ...(view && { view }),
      ...(filter && { filter }),
      ...(sortby && { sortby }),
      ...(source && { source }),
    };
    return this.client.get(`/${ns}/lists`, queryParams);
  }

  /**
   * Get all lists (no pagination)
   */
  getAllLists(namespace) {
    const ns = normalizeNamespace(namespace);
    // TODO: implement fetching all lists with pagination and auto-suggestion, delete this method
    const queryParams = { offset: 0, limit: 1000 };
    return this.client.get(`/${ns}/lists`, queryParams);
  }

  /**
   * Get single list by ID
   */
  getList(namespace, listId) {
    const ns = normalizeNamespace(namespace);
    return this.client.get(`/${ns}/lists/${listId}`);
  }

  /**
   * Create new list
   */
  createList(namespace, listInfo) {
    const ns = normalizeNamespace(namespace);
    return this.client.post(`/${ns}/lists`, listInfo);
  }

  /**
   * Bookmark a public list.
   */
  bookmarkList(listId) {
    return this.client.post('/private/lists', { id: listId });
  }

  /**
   * Update list
   */
  updateList(namespace, listId, patch) {
    const ns = normalizeNamespace(namespace);
    return this.client.patch(`/${ns}/lists/${listId}`, patch);
  }

  /**
   * Delete list
   */
  deleteList(namespace, listId) {
    const ns = normalizeNamespace(namespace);
    return this.client.delete(`/${ns}/lists/${listId}`);
  }

  /**
   * Add items to list
   */
  addItemsToList(namespace, listId, items) {
    const ns = normalizeNamespace(namespace);
    return this.client.post(`/${ns}/lists/${listId}/items`, items);
  }

  /**
   * Remove item from list
   */
  removeItemFromList(namespace, listId, itemId) {
    const ns = normalizeNamespace(namespace);
    return this.client.delete(`/${ns}/lists/${listId}/items/${itemId}`);
  }

  /**
   * Remove items from list (batch)
   */
  removeItemsFromList(namespace, listId, items) {
    const ns = normalizeNamespace(namespace);
    return this.client.delete(`/${ns}/lists/${listId}/items`, items);
  }

  /**
   * Share list (create pending copy for approval)
   */
  shareList(listId) {
    return this.client.post(`/pending/lists/${listId}`);
  }
}

export default ListsApi;
